var render = function (_h,_vm) {var _c=_vm._c;return _c('b-card',{staticClass:"card-box overflow-hidden"},[[_c('div',{},[_c('h4',{staticClass:"card-box_header"},[_vm._v("\n        "+_vm._s(_vm.props.title)+"\n      ")])])],_c('div',{staticClass:"card-box_body"},[_vm._t("body")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }